import { Info } from '@phosphor-icons/react';
import { useState } from 'react';

export function HelpTooltip({ text }) {
  const [show, setShow] = useState(false);
  return (
    <span className="relative inline-block">
      <Info size={14} className="inline ml-1 text-gray-400 hover:text-blue-500 cursor-help" onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)} onClick={() => setShow(!show)} />
      {show && (
        <div className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 p-3 text-xs text-white bg-gray-900 rounded-lg shadow-lg" style={{pointerEvents:'none'}}>
          {text}
          <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-1 w-2 h-2 bg-gray-900 rotate-45" />
        </div>
      )}
    </span>
  );
}
